<script>
// Custom Components
import PbxService from "@/helpers/APIService/pbx.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";

export default {
  data() {
    return {
      title: "Notes of",
      plugins: [
        "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table contextmenu directionality emoticons template paste textcolor",
      ],
      toolbar:
        "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons",
      options: {
        height: 680,
        style_formats: [
          { title: "Bold text", inline: "b" },
          { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
          { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
          { title: "Example 1", inline: "span", classes: "example1" },
          { title: "Example 2", inline: "span", classes: "example2" },
          { title: "Table styles" },
          { title: "Table row 1", selector: "tr", classes: "tablerow1" },
        ],
      },
      note: "",
      isBtnLoading: false,
    };
  },
  props: {
    notes: Object,
  },
  mounted() {
    setTimeout(() => {
      this.note = this.notes.domain_data.notes;
    }, 500);
  },
  methods: {
    // Method is used to handle update notes
    onSubmit() {
      this.isBtnLoading = true;
      PbxService.updateDomainStatus(this.notes.domain_data.domain_uuid, {
        notes: this.note,
      })
        .then((response) => {
          this.isBtnLoading = false;
          if (response.status == false) {
            return Middleware.notification(response.message, "danger");
          } else {
            this.$router.push("/customer-list");
            Middleware.notification("Successfully updated !!", "success");
          }
        })
        .catch((error) => {
          this.isBtnLoading = false;
          errorHandler(error);
        });
    },
  },
};
</script>

<template>
  <div>
    <tinymce
      id="tinyMce-editor"
      :plugins="plugins"
      :toolbar="toolbar"
      :other_options="options"
      v-model="note"
    ></tinymce>
    <b-button
      class="float-end mt-3"
      variant="primary"
      type="submit"
      :disabled="isBtnLoading"
      @click.prevent="onSubmit"
    >
      <i
        class="bx bx-loader bx-spin font-size-16 align-middle me-2"
        v-if="isBtnLoading"
      ></i>
      Save
    </b-button>
  </div>
</template>
